module.exports = __webpack_public_path__ + "static/media/blank-sketches-2.7efea880.svg";